'use strict';

angular.module('atex.dam').controller('DamDrawerController', ['$scope', '$rootScope', '$window', 'ContentService', 'CollectionService', '$q', '$state', 'DrawerService', 'DamService', 'DamActivityService', 'ClipboardService', '$translate', 'DamNotificationService','DamFileService', 'DamListService',
function($scope, $rootScope, $window, ContentService, CollectionService, $q, $state, DrawerService, DamService, DamActivityService, ClipboardService, $translate, DamNotificationService,DamFileService, DamListService) {

  $scope.entries = DrawerService.getItems();
  $scope.collection = DrawerService.getCollection();
  $scope.lastSavedEntries = [];
  $scope.networking = false;
  $scope.creatingCollections = false;

  var tickSpan = 20;
  var maxTick = 1000;
  $scope.tick = maxTick;

  $scope.clear = function () {
    DrawerService.clear();
    $scope.tick = maxTick;
    $scope.lastSavedEntries = [];
    $scope.networking = false;
    $scope.creatingCollections = false;
  };

  $scope.canChange = function () {
    if ($state.current.name === "list.collection" && $state.params.id === $scope.collection.id) {
      if (CollectionService.getDirty()) {
        // If the collection is dirty in the main view, we cannot modify it in the drawer panel!
        return false;
      }
    }
    return true;
  };

  $scope.isDirty = function () {
    return $scope.canChange() && !$scope.lastSavedEntries.equals($scope.entries);
  };

  $scope.canAddEntry = function (entry) {
    if (!$scope.canChange() || !DrawerService.canCollectType(entry.aspects['contentData'].data.inputTemplate)) {
      return false;
    }
    return true;
  };

    $scope.addEntry = function (contentId) {
    var index = $scope.entries.ArrayIndexOf(function (entry) {
      return entry.id === atex.dam.AngularUtils.removePrefix(contentId);
    });

    if (index >= 0) {
      return;
    }
    var transferInfo = {id: contentId, variant: 'list'};
    ContentService.getContent(transferInfo).then(function (response) {
      if ($scope.canAddEntry(response.data)) {
        atex.dam.AngularUtils.fixUrls(response.data);
        if (window.atex.dam.cfg.addNewCollectionItemsOnTop) {
          $scope.entries.unshift(response);
        } else {
          $scope.entries.push(response);
        }
      }
    }).then(null, function (error) {
      console.log('ERROR: Getting content:', error);
    });
  };

  $scope.removeEntry = function (entry) {
    if (!$scope.canChange()) {
      return false;
    }
    var index = $scope.entries.indexOf(entry);
    if (index >= 0) {
      $scope.entries.splice(index, 1);
    }
  };

  $scope.openInEditor = function(entry) {
    var deferred = $q.defer();
    DamActivityService.getLockData([entry.id]).then(function(lockData) {
      if (lockData.edit) {
        DamActivityService.notifyItemLocked(lockData.getUserName());
        deferred.reject({});
      } else {
        $window.open('/act/#/edit/' + entry.id, '_blank').focus();
        deferred.resolve();
      }
    }).then(null, function(error) {
      deferred.reject(error);
    });
    return deferred.promise;
  };

  // D&D
  $scope.handleDowerDragStart = function (e) {
    if ($scope.canChange() && this.attributes.contentId.value && this.attributes.type.value) {
      this.style.opacity = '0.4';
      var obj = {};
      obj._data = {};
      obj._data.id = this.attributes.contentId.value;

      obj._data.aspects = {};
      obj._data.aspects.contentData = {};
      obj._data.aspects.contentData.data = {};
      obj._data.aspects.contentData.data.inputTemplate = this.attributes.type.value;
      var objs = [obj];
      e.originalEvent.dataTransfer.setData('Text', $scope.createDragUrl(objs));
    }
  };
  $scope.handleDowerDragOver = function (e) {
    e.originalEvent.dataTransfer.dropEffect = 'link';
    e.preventDefault();
    return false;
  };
  $scope.handleDowerDragEnd = function (e) {
    this.style.opacity = '1';
  };
  $scope.handleDowerDrop = function (e) {
    if (!$scope.canChange()) {
      return;
    }
    if (e.preventDefault) {
      e.preventDefault();
    }
    if (e.stopPropagation) {
      e.stopPropagation();
    }
    var destId = this.attributes.contentId.value;
    var dataText = e.originalEvent.dataTransfer.getData('Text');
    var dragIds = $scope.getIdsFromDragUrl(dataText);

    angular.forEach(dragIds, function (dragId) {
      if (destId === dragId) {
        return false;
      }
      if (dragId.length > 0) {
        var iSrc = $scope.entries.ArrayIndexOf(function (entry) {
          return entry.id === dragId;
        });
        var iDst = $scope.entries.ArrayIndexOf(function (entry) {
          return entry.id === destId;
        });
        if (iSrc >= 0 && iDst >= 0) {
          // iSrc and iDst are valid then we are switching order
          var movingEntry = $scope.entries[iSrc];
          $scope.$apply(function () {
            $scope.entries.splice(iSrc, 1);
            $scope.entries.splice(iDst, 0, movingEntry);
          });
        } else if (iSrc < 0 && iDst >= 0) {
          // We are dragging from outside and dropping over a drawer element
          $scope.$apply(function () {
            var transferInfo = {id: dragId, variant: 'list'};
            ContentService.getContent(transferInfo).then(function (response) {
              atex.dam.AngularUtils.fixUrls(response.data);
              $scope.entries.push(response);
            }).then(null, function (error) {
              console.log('ERROR: Getting content:', error);
            });
          });
        }
      }
    });
    return false;
  };

  $scope.handleDragOver = function (e) {
    e.originalEvent.dataTransfer.dropEffect = 'link';
    e.preventDefault();
    return false;
  };

  var isImageType = function (type) {
    if (type.match('image.*')) {
      return true;
    }
    return false;
  };

  var isLocalImage = function (event) {
    if (event && event.originalEvent.dataTransfer && event.originalEvent.dataTransfer.files && event.originalEvent.dataTransfer.files.length > 0) {
      for (var i = 0; i < event.originalEvent.dataTransfer.files.length; i++) {
        if (isImageType(event.originalEvent.dataTransfer.files[i].type)) {
          return true;
        }
      }
    }
    return false;
  };

  var filterImages = function (files) {
    var images = [];
    files.forEach(function (file) {
      if (isImageType(file.type)) {
        images.push(file);
      }
    });
    return images;
  };

  var uploadImage = function (file) {
    return $q.when().then(function () {
      return DamFileService.prepareImageData(file, "externalid/dam.assets.common.d").then(function (data) {
        return ContentService.createContent({data: data}).then(function (response) {
          return response.id;
        });
      });
    });
  };

  var uploadImages = function (files) {
    return $q.when().then(function () {
      var promises = files.map(function (file) {
        return uploadImage(file);
      });
      return $q.all(promises).then(function (results) {
        return results;
      });
    });
  };

  $scope.handleDrop = function (e) {
    if (!$scope.canChange()) {
      DamNotificationService.addNotification(atex.dam.Notification({
        type: 'error',
        message:  $translate.getTranslationTable().__COLLECTION_UPLOAD_ERROR__
      }), true);
      return;
    }

    if (e.preventDefault) {
      e.preventDefault();
    }
    if (e.stopPropagation) {
      e.stopPropagation();
    }
    var dataText = e.originalEvent.dataTransfer.getData('Text');
    if (dataText.length > 0) {
      var dragIds = $scope.getIdsFromDragUrl(dataText);
      angular.forEach(dragIds, function (dragId) {
        var i = $scope.entries.ArrayIndexOf(function (entry) {
          return entry.id === dragId;
        });
        if (i < 0) {
          $scope.$apply(function () {
            $scope.addEntry(dragId);
          });
        }
      });
    } else {
      if (isLocalImage(e)) {
        $scope.creatingImages = true;
        var fileList = Array.from(e.originalEvent.dataTransfer.files);
        var images = filterImages(fileList);
        uploadImages(images).then(function (results) {
          _.each(results, function (result) {
            $scope.addEntry(result);
          });
          DamNotificationService.addNotification(atex.dam.Notification({
            type: 'success',
            message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__
          }), false);
          $scope.creatingImages = false;
        }).then(null, function (error) {
          DamNotificationService.addNotification(atex.dam.Notification({
            type: 'error',
            message: $translate.getTranslationTable().__COLLECTION_UPLOAD_IMAGE_ERROR__
          }), true);
          $scope.creatingImages = false;
        });
      }
    }
  };
  //D&D (End)

  $scope.createCollection = function (collectionName) {
    $scope.creatingCollections = true;
    CollectionService.createCollectionUI($scope.entries, collectionName).then(function (response) {
      DrawerService.setCollection(response);
      $scope.lastSavedEntries = $scope.entries.slice(0);
      $rootScope.$broadcast("dam:collectionCreated", $scope.collection);
      $scope.creatingCollections = false;
      DamNotificationService.addNotification(atex.dam.Notification({
        type: 'success',
        message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__
      }), false);
    }).then(null, function (error) {
      $scope.creatingCollections = false;
      if (error) {
        if (!atex.dam.isTest) {
          alert(error.cause);
        }
        console.log('ERROR: Creating collection list container', error);
      }
      DamNotificationService.addNotification(atex.dam.Notification({
        type: 'error',
        message: $translate.getTranslationTable().__GENERIC_ERROR_MSG__
      }), true);
    });
  };

  var _updateCollection = function () {
    var deferred = $q.defer();
    CollectionService.updateCollection($scope.collection, $scope.entries).then(function (response) {
      DrawerService.setCollection(response);
      $scope.lastSavedEntries = $scope.entries.slice(0);
      $scope.saving = true;
      $rootScope.$broadcast("dam:collectionUpdated", $scope.collection.id);
      $scope.saving = false;
      DamNotificationService.addNotification(atex.dam.Notification({
        type: 'success',
        message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__
      }), false);
      deferred.resolve(response);
    }).then(null, function (error) {
      console.log('ERROR: Updating collection list container', error);
      deferred.reject(error);
      if (!atex.dam.isTest && error) {
        alert(error.cause);
      }
      DamNotificationService.addNotification(atex.dam.Notification({
        type: 'error',
        message: $translate.getTranslationTable().__GENERIC_ERROR_MSG__
      }), true);
    });
    return deferred.promise;
  };

  $scope.updateCollection = function () {
    $scope.networking = true;
    // Check if the $scope.collection.id is already in editing and in that case update only without locking again
    if ($state.current.name === "list.collection" && $state.params.id === $scope.collection.id) {
      // Check if the collection is dirty in the main view
      if (CollectionService.getDirty()) {
        return;
      }
      _updateCollection().finally(function () {
        $scope.networking = false;
        if ($scope.collection.id !== undefined && window.location.href.includes($scope.collection.id)){
          window.location.reload();
        }
      });
    } else {
      var locked = false;
      DamActivityService.lock([$scope.collection.id]).then(function (lockData) {
        locked = true;
        return _updateCollection();
      }).finally(function () {
        $scope.networking = false;
        if (locked) {
          DamActivityService.unlock([$scope.collection.id]);
        }
      });
    }
  };

  $scope.$on("dam:collectionRetrieved", function (event, collection) {
    $scope.clear();
    $scope.tick = tickSpan;
    DrawerService.setCollection(collection);
    CollectionService.getAllCollectionItems($scope.collection).then(function (collectionItems) {
      DrawerService.setItems(collectionItems);
      $scope.lastSavedEntries = $scope.entries.slice(0);
    }).then(undefined, function (error) {
      console.log('Error while loading collection items!', error);
    });
  });

  $scope.$on("dam:collectionDeleted", function (event, collection) {
    if ($scope.collection && $scope.collection.id === collection.id) {
      $scope.clear();
    }
  });

  $scope.loadInResultSet = function () {
    if ($scope.collection.id) {
      if (DamService.isMobileDevice()) {
        $rootScope.$broadcast("dam:toggle");
      }
      $state.go('list.collection', {'id': $scope.collection.id, 'preview': null});

    }
  };

  $scope.importFromResultSet = function() {
    var selected = DamListService.getSelected();
    if (selected && selected.length > 0) {
      var _content = selected[0];
      var type = atex.onecms.ObjectUtils.getByPath(_content, '_data/aspects/contentData/data/objectType');
      if ("collection" === type) {
        ContentService.getContent({id: _content.id}).then(function (collection) {
          $scope.clear();
          $scope.tick = tickSpan;
          DrawerService.setCollection(collection);
          CollectionService.getAllCollectionItems($scope.collection).then(function (collectionItems) {
            DrawerService.setItems(collectionItems);
            $scope.lastSavedEntries = $scope.entries.slice(0);
            DamNotificationService.addNotification(atex.dam.Notification({
              type: 'success',
              message: $translate.getTranslationTable().__COLLECTION_IMPORTED_CORRECTLY__
            }), false);
          });
        }).then(null, function (error) {
          DamNotificationService.addNotification(atex.dam.Notification({
            type: 'error',
            message: $translate.getTranslationTable().__ERROR_DURING_COLLECTION_LOADING__ + JSON.stringify(error)
          }), true);
        });
      } else {
        DamNotificationService.addNotification(atex.dam.Notification({
          type: 'error',
          message: $translate.getTranslationTable().__COLLECTION_CONTENT_NOT_ALLOWED__
        }), true);
      }
    } else {
      DamNotificationService.addNotification(atex.dam.Notification({
        type: 'error',
        message: $translate.getTranslationTable().__NO_CONTENT_SELECTED__
      }), true);
    }
  };

  $scope.$on("dam:logout", function () {
    $scope.clear();
  });

  $scope.$on("dam:collectionUpdated", function (event, collectionId) {
    if (!$scope.saving && $scope.collection.id && $scope.collection.id === collectionId) {
      ContentService.getContent({id: collectionId}).then(function (responseInfo) {
        $rootScope.$broadcast("dam:collectionRetrieved", responseInfo);
      });
    }
  });

  $scope.$on("dam:addItemToCollector", function (event, contentId) {
    $scope.addEntry(contentId);
  });

  $scope.loadMore = function () {
    $scope.tick += tickSpan;
  };

  $scope.pasteFromClipboard = function(event) {
    if (event && typeof event.stopPropagation !== 'undefined') {
      event.stopPropagation();
    }

    if ($scope.pasting === true) {
      return;
    }

    $scope.pasting = true;

    ClipboardService.getClipboard().then(function (clipboardContent) {
      var clipboardData = clipboardContent.data;

      var promises = [];
      clipboardData.forEach(function (content) {
        $scope.addEntry(content.id);
      });

      return atex.onecms.AngularUtils.allSettled($q, promises);
    }).then(undefined, function (error) {
      DamNotificationService.addNotification(atex.dam.Notification({
        type: 'error',
        message:  $translate.getTranslationTable().__COLLECTION_UPLOAD_IMAGE_ERROR__  + JSON.stringify(error)
      }), true);
    }).then(function () {
      $scope.pasting = false;
    });
  };

  $scope.copyCollectionToClipboard = function () {
    if (!$scope.collection.id) {
      return;
    }
    var clipboardInfo = {};
    clipboardInfo.data = [];
    var data = {
      id: 'contentid/' + $scope.collection.id,
      type: 'atex.dam.standard.Collection'
    };
    clipboardInfo.data.push(data);
    return ClipboardService.putInClipboard(clipboardInfo).then(function (response) {
      DamNotificationService.addNotification(atex.dam.Notification({
        type: 'success',
        message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__
      }), false);
    }, function (error) {
      DamNotificationService.addNotification(atex.dam.Notification({
        type: 'error',
        message: $translate.getTranslationTable().__ERROR_RETRIEVE_CLIPBOARD__
      }), true);
    });
  };
}]);